document.addEventListener('DOMContentLoaded', function() {
  // Animation timing constants
  const ANIMATION_DELAY_MS = 20;
  const ANIMATION_DURATION_MS = 270;
  const SWIPE_THRESHOLD_PX = 50;

  // Quantity selector functionality
  const quantityInput = document.getElementById('quantity-input');
  const decreaseBtn = document.querySelector('.quantity-decrease');
  const increaseBtn = document.querySelector('.quantity-increase');
  const cartQuantityInput = document.getElementById('cart-quantity');

  if (quantityInput && decreaseBtn && increaseBtn) {
    // Minus button
    decreaseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      let currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        currentValue--;
        quantityInput.value = currentValue;
        if (cartQuantityInput) {
          cartQuantityInput.value = currentValue;
        }
      }
    });

    // Plus button
    increaseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      let currentValue = parseInt(quantityInput.value) || 1;
      const maxValue = parseInt(quantityInput.getAttribute('max')) || 999;
      if (currentValue < maxValue) {
        currentValue++;
        quantityInput.value = currentValue;
        if (cartQuantityInput) {
          cartQuantityInput.value = currentValue;
        }
      }
    });

    // Update hidden input when user types directly
    quantityInput.addEventListener('input', function() {
      let value = parseInt(this.value) || 1;
      const minValue = parseInt(this.getAttribute('min')) || 1;
      const maxValue = parseInt(this.getAttribute('max')) || 999;
      
      if (value < minValue) value = minValue;
      if (value > maxValue) value = maxValue;
      
      this.value = value;
      if (cartQuantityInput) {
        cartQuantityInput.value = value;
      }
    });

    // Also validate on blur (when user clicks away)
    quantityInput.addEventListener('blur', function() {
      let value = parseInt(this.value) || 1;
      const minValue = parseInt(this.getAttribute('min')) || 1;
      const maxValue = parseInt(this.getAttribute('max')) || 999;
      
      if (value < minValue) value = minValue;
      if (value > maxValue) value = maxValue;
      
      this.value = value;
      if (cartQuantityInput) {
        cartQuantityInput.value = value;
      }
    });
  }

  // Only run on product pages
  if (document.querySelector('.product-container')) {
    // Image gallery functionality
    let mainImage = document.getElementById('mainProductImage');
    const thumbnails = document.querySelectorAll('.thumbnail-item');
    const mainPrevBtn = document.querySelector('.main-image-nav-btn.prev-main');
    const mainNextBtn = document.querySelector('.main-image-nav-btn.next-main');

    // Create array of all images
    const allImages = Array.from(thumbnails).map(thumb => ({
      src: thumb.getAttribute('data-image-src'),
      id: thumb.getAttribute('data-image-id'),
      index: parseInt(thumb.getAttribute('data-image-index'))
    }));

    // Update main image and active thumbnail
    function updateMainImage(index, direction = 'next') {
      // Validate allImages array is not empty
      if (!allImages || allImages.length === 0) {
        return;
      }

      const currentIndex = parseInt(mainImage.getAttribute('data-current-index') || '0');

      // Handle circular navigation
      if (index < 0) {
        index = allImages.length - 1;
      } else if (index >= allImages.length) {
        index = 0;
      }

      // Don't transition if same image
      if (index === currentIndex) return;

      const imageData = allImages[index];
      if (mainImage && imageData) {
        // Create new image element for next image
        const newImage = document.createElement('img');
        newImage.src = imageData.src;
        newImage.alt = mainImage.alt;

        // Position new image based on direction
        if (direction === 'next') {
          newImage.classList.add('next-image-right'); // Start on the right
          mainImage.classList.add('current-image');
        } else {
          newImage.classList.add('next-image-left'); // Start on the left
          mainImage.classList.add('current-image');
        }

        mainImage.parentElement.appendChild(newImage);

        // Trigger slide animation after a brief delay
        setTimeout(() => {
          if (direction === 'next') {
            mainImage.classList.add('sliding-left'); // Current slides left
            newImage.classList.remove('next-image-right');
            newImage.classList.add('current-image'); // New slides to center
          } else {
            mainImage.classList.add('sliding-right'); // Current slides right
            newImage.classList.remove('next-image-left');
            newImage.classList.add('current-image'); // New slides to center
          }
        }, ANIMATION_DELAY_MS);

        // Clean up after animation
        setTimeout(() => {
          if (mainImage.parentElement) {
            mainImage.remove();
          }
          // Make newImage the main image
          newImage.id = 'mainProductImage';
          newImage.setAttribute('data-current-index', index);
          newImage.classList.remove('sliding-left', 'sliding-right', 'next-image-left', 'next-image-right');

          // Update global reference to new image
          mainImage = newImage;

          // Add click handler for lightbox
          mainImage.addEventListener('click', function() {
            const currentIndex = parseInt(this.getAttribute('data-current-index') || '0');
            openLightbox(currentIndex);
          });
        }, ANIMATION_DURATION_MS);

        // Update active state
        thumbnails.forEach((t, i) => {
          if (i === index) {
            t.classList.add('active');
          } else {
            t.classList.remove('active');
          }
        });
      }
    }

    // Handle thumbnail clicks
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', function() {
        updateMainImage(index);
      });
    });

    // Main image navigation buttons
    if (mainPrevBtn) {
      mainPrevBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        const currentIndex = parseInt(mainImage.getAttribute('data-current-index') || '0');
        updateMainImage(currentIndex - 1, 'prev');
      });
    }

    if (mainNextBtn) {
      mainNextBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        const currentIndex = parseInt(mainImage.getAttribute('data-current-index') || '0');
        updateMainImage(currentIndex + 1, 'next');
      });
    }

    // Image zoom functionality
    if (mainImage) {
      mainImage.addEventListener('click', function() {
        const currentIndex = parseInt(this.getAttribute('data-current-index') || '0');
        openLightbox(currentIndex);
      });
    }

    // Touch swipe functionality for main image - simple and clean
    let touchStartX = 0;
    let touchEndX = 0;
    const mainImageContainer = document.querySelector('.product-image-main');
    
    if (mainImageContainer) {
      mainImageContainer.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainImageContainer.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });

      function handleSwipe() {
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > SWIPE_THRESHOLD_PX) {
          const currentIndex = parseInt(mainImage.getAttribute('data-current-index') || '0');
          
          if (diff > 0) {
            // Swiped left - show next image
            updateMainImage(currentIndex + 1, 'next');
          } else {
            // Swiped right - show previous image
            updateMainImage(currentIndex - 1, 'prev');
          }
        }
      }
    }

    function openLightbox(imageIndex) {
      // Create lightbox if it doesn't exist
      let lightbox = document.querySelector('.image-lightbox');
      if (!lightbox) {
        lightbox = document.createElement('div');
        lightbox.className = 'image-lightbox';
        lightbox.innerHTML = `
          <span class="lightbox-close">&times;</span>
          <button class="lightbox-nav-btn prev-lightbox" aria-label="Previous image">‹</button>
          <img src="" alt="" data-lightbox-index="0">
          <button class="lightbox-nav-btn next-lightbox" aria-label="Next image">›</button>
        `;
        document.body.appendChild(lightbox);

        // Handle clicks on the lightbox
        lightbox.addEventListener('click', function(e) {
          const lightboxImg = lightbox.querySelector('img');

          // Close if clicking close button or background
          if (e.target === lightbox || e.target.classList.contains('lightbox-close')) {
            closeLightbox();
          }
          // Toggle zoom on image click
          else if (e.target === lightboxImg) {
            e.stopPropagation();
            toggleImageZoom(lightboxImg, e);
          }
        });

        // Touch swipe functionality for lightbox
        let lightboxTouchStartX = 0;
        let lightboxTouchEndX = 0;

        lightbox.addEventListener('touchstart', function(e) {
          lightboxTouchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        lightbox.addEventListener('touchend', function(e) {
          lightboxTouchEndX = e.changedTouches[0].screenX;
          handleLightboxSwipe();
        }, { passive: true });

        function handleLightboxSwipe() {
          const diff = lightboxTouchStartX - lightboxTouchEndX;

          if (Math.abs(diff) > SWIPE_THRESHOLD_PX) {
            const lightboxImg = lightbox.querySelector('img');
            const currentIndex = parseInt(lightboxImg.getAttribute('data-lightbox-index') || '0');
            
            if (diff > 0) {
              // Swiped left - show next image
              updateLightboxImage(currentIndex + 1);
            } else {
              // Swiped right - show previous image
              updateLightboxImage(currentIndex - 1);
            }
          }
        }

        // Lightbox navigation buttons
        const lightboxPrevBtn = lightbox.querySelector('.lightbox-nav-btn.prev-lightbox');
        const lightboxNextBtn = lightbox.querySelector('.lightbox-nav-btn.next-lightbox');

        if (lightboxPrevBtn) {
          lightboxPrevBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            const lightboxImg = lightbox.querySelector('img');
            const currentIndex = parseInt(lightboxImg.getAttribute('data-lightbox-index') || '0');
            updateLightboxImage(currentIndex - 1);
          });
        }

        if (lightboxNextBtn) {
          lightboxNextBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            const lightboxImg = lightbox.querySelector('img');
            const currentIndex = parseInt(lightboxImg.getAttribute('data-lightbox-index') || '0');
            updateLightboxImage(currentIndex + 1);
          });
        }

        // Close on escape key, navigate with arrow keys
        document.addEventListener('keydown', function(e) {
          if (!lightbox.classList.contains('active')) return;

          if (e.key === 'Escape') {
            closeLightbox();
          } else if (e.key === 'ArrowLeft') {
            const lightboxImg = lightbox.querySelector('img');
            const currentIndex = parseInt(lightboxImg.getAttribute('data-lightbox-index') || '0');
            updateLightboxImage(currentIndex - 1);
          } else if (e.key === 'ArrowRight') {
            const lightboxImg = lightbox.querySelector('img');
            const currentIndex = parseInt(lightboxImg.getAttribute('data-lightbox-index') || '0');
            updateLightboxImage(currentIndex + 1);
          }
        });
      }

      // Update lightbox image
      updateLightboxImage(imageIndex);
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    }

    function updateLightboxImage(index) {
      // Validate allImages array is not empty
      if (!allImages || allImages.length === 0) {
        return;
      }

      // Handle circular navigation
      if (index < 0) {
        index = allImages.length - 1;
      } else if (index >= allImages.length) {
        index = 0;
      }

      const lightbox = document.querySelector('.image-lightbox');
      if (!lightbox) return;

      const lightboxImg = lightbox.querySelector('img');

      if (lightboxImg && allImages[index]) {
        // Remove zoom if active
        lightboxImg.classList.remove('zoomed');
        lightboxImg.style.transformOrigin = 'center center';

        // Update image
        lightboxImg.src = allImages[index].src;
        lightboxImg.alt = mainImage.alt;
        lightboxImg.setAttribute('data-lightbox-index', index);
      }
    }

    function closeLightbox() {
      const lightbox = document.querySelector('.image-lightbox');
      if (lightbox) {
        const lightboxImg = lightbox.querySelector('img');
        if (lightboxImg) {
          lightboxImg.classList.remove('zoomed');
        }
        lightbox.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
      }
    }

    function toggleImageZoom(img, event) {
      if (img.classList.contains('zoomed')) {
        // Zoom out
        img.classList.remove('zoomed');
        img.style.transformOrigin = 'center center';
      } else {
        // Zoom in at click position
        const rect = img.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        img.classList.add('zoomed');
      }
    }
  }
});
